import type { Address } from '@morpho-org/blue-sdk'
import type { ChainId, MarketId } from '@morpho-org/blue-sdk'
import type { InterfaceInputToken, InterfaceToken } from '@morpho-org/dapp-core'
import type { Hash, Hex } from 'viem'

import type { Warning } from '@/components/common/WarningIcon'

import { TransactionType } from '@/types/legacy'

export interface EarnActivityTableRow {
  urlHash: string
  typeText: string
  chainId: ChainId
  timestamp?: bigint
  asset?: InterfaceToken | null
  amount?: bigint
  amountUsd?: number | null
  transactionHash: Hex
  type: string
  filterType?: EarnTransactionType
  isVaultV2: boolean
  vaultAddress: Address
  vaultName: string
  vaultWarnings: Warning[]
}

export interface BorrowActivityTableRow {
  urlHash: string
  typeText: string
  type: string
  chainId: ChainId
  timestamp: bigint
  collateralAsset?: InterfaceInputToken | null
  loanAsset?: InterfaceInputToken | null
  warnings: Warning[]
  lltv?: bigint | null
  token?: InterfaceToken | null
  usdValue?: bigint | null
  amount: bigint
  hash: Hex
  marketId?: MarketId
}

export enum EarnTransactionType {
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  Transfer = 'Transfer'
}

export const EarnTransactionTypeMap: Record<EarnTransactionType, [TransactionType, string]> = {
  [EarnTransactionType.Deposit]: [TransactionType.MetaMorphoDeposit, 'Deposit'],
  [EarnTransactionType.Withdraw]: [TransactionType.MetaMorphoWithdraw, 'Withdraw'],
  [EarnTransactionType.Transfer]: [TransactionType.MetaMorphoTransfer, 'Transfer']
}

export interface LiquidationActivityTableRow {
  chainId: ChainId
  collateralAsset?: InterfaceToken | null
  loanAsset?: InterfaceToken | null
  date: {
    timestamp: bigint
  }
  liquidated: {
    address: Address
  }
  liquidator: {
    address: Address
  }
  tx: {
    hash: Hash
  }
  collateralSeized: {
    amount?: bigint | null
    amountUsd?: bigint | null
  }
  loanRepaid: {
    amount?: bigint | null
    amountUsd?: bigint | null
  }
  realizedBadDebt: {
    amount?: bigint | null
    amountUsd?: bigint | null
    warning?: Warning | null
  }
  marketId: MarketId
  lltv: bigint
}
